import { render } from "./App.vue?vue&type=template&id=ba7bb59e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ba7bb59e&lang=css"
script.render = render

export default script